/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AnalyticsProvider } from '../AnalyticsProvider';

export default class TikTokPixelProvider implements AnalyticsProvider {
  name = 'tiktok';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(eventName: string, properties?: Record<string, any>): void {
    // @ts-ignore
    window.ttq.track(eventName, properties);
  }
}
